import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  ISeasonsPage,
  IQuestsPage,
  ISeasonalUserScore,
  ISeasonPrizesPage,
  IScoreRewardsPage,
} from './seasons.interfaces';

@Injectable({ providedIn: 'root' })
export class SeasonsService {
  private readonly url = environment.GATEWAY_URL + '/seasonal-quests';
  constructor(private readonly http: HttpClient) {}
  getSeasons(userId: number, params: object): Observable<ISeasonsPage> {
    return this.http.post<ISeasonsPage>(
      `${this.url}/${userId}/seasons/get`,
      params,
    );
  }
  getQuests(userId: number, params: object): Observable<IQuestsPage> {
    return this.http.post<IQuestsPage>(
      `${this.url}/${userId}/quests/get`,
      params,
    );
  }
  getScore(
    userId: number,
    seasonId: number,
  ): Observable<ISeasonalUserScore> {
    return this.http.post<ISeasonalUserScore>(
      `${this.url}/${userId}/score/get`,
      { seasonId },
    );
  }
  updateScore(userId: number, params: object): Observable<ISeasonalUserScore> {
    return this.http.post<ISeasonalUserScore>(
      `${this.url}/${userId}/score/update`,
      params,
    );
  }
  getPrizes(userId: number, params: object): Observable<ISeasonPrizesPage> {
    return this.http.post<ISeasonPrizesPage>(
      `${this.url}/${userId}/season-prizes/get`,
      params,
    );
  }
  getScoreRewards(
    userId: number,
    params: object,
  ): Observable<IScoreRewardsPage> {
    return this.http.post<IScoreRewardsPage>(
      `${this.url}/${userId}/score-rewards/get`,
      params,
    );
  }
}
